const formatNumberToCurrency = (number, decimal = 2) => {
    return number.toLocaleString('pt-BR', { minimumFractionDigits: decimal });
};

export { formatNumberToCurrency };
